import { FC } from "react";
import RegionWebLayout from "./WebLayout";

const Region: FC = () => {
  return (
    <div>
      <RegionWebLayout />
    </div>
  );
};

export default Region;
